import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=3226036e&scoped=true&"
import script from "./formList.vue?vue&type=script&lang=js&"
export * from "./formList.vue?vue&type=script&lang=js&"
import style0 from "./formList.vue?vue&type=style&index=0&id=3226036e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226036e",
  null
  
)

export default component.exports